// ============================================
// ConverseTech Frontend - Feedback Panel
// ============================================

import type { TrainingMode } from '@conversetech/shared';

interface FeedbackPanelProps {
  mode: TrainingMode | null;
}

export default function FeedbackPanel({ mode }: FeedbackPanelProps) {
  return (
    <div data-testid="feedback-panel" className="card bg-gray-800 p-4">
      <h3 className="text-sm font-medium text-gray-400 mb-4">AI Feedback</h3>

      <div className="space-y-3 text-sm text-gray-300">
        {mode === 'conversation' && (
          <p>Focus on fluency. Keep the conversation flowing naturally.</p>
        )}
        {mode === 'technical_explanation' && (
          <p>Remember the structure: Context, Problem, Solution, Trade-offs.</p>
        )}
        {mode === 'mock_interview' && (
          <p>Be concise and specific. Use concrete examples.</p>
        )}
        {mode === 'duolingo_test' && (
          <p>Watch your time. Stay focused on the task.</p>
        )}
        {!mode && (
          <p className="text-gray-500">Select a mode to see relevant feedback.</p>
        )}
      </div>
    </div>
  );
}
